export const TOKEN_EXPIRED = 'SITE.TOKEN_EXPIRED' // token 无效事件
export const WITHOUT_PERMISSION = 'WITHOUT_PERMISSION' // 无权限
export const TAB_CLOSE = 'SITE.TAB_CLOSE' // 关闭 tab 事件
export const TAB_SET_TITLE = 'SITE.TAB_SET_TITLE' // 设置 tab 标题
// export const SYS_EDFAULT = 'SITE.SYS_EDFAULT' // 默认调用
// export const RESET_PAGINATION = 'RESET_PAGINATION' // 重置列表页码

export const LOGOUT = 'LOGOUT' // 退出登录
export const OPEN_LOGIN = 'OPEN_LOGIN' // 去登录
export const OPEN_REGISTER = 'OPEN_REGISTER' // 去注册
export const OPEN_RESET_PASSWORD = 'OPEN_RESET_PASSWORD' // 找回密码
export const OPEN_JOIN_CORP_DIALOG = 'OPEN_JOIN_CORP_DIALOG' //打开合伙人入驻窗口
export const CLOSE_JOIN_CORP_DIALOG = 'CLOSE_JOIN_CORP_DIALOG' //关闭合作人入驻窗口
export const REFRESH_JOIN_CORP_STATUS = 'REFRESH_JOIN_CORP_STATUS' //合伙人入驻审核状态刷新

export const OPEN_PARTNER_MODE_DIALOG = 'OPEN_PARTNER_MODE_DIALOG' //打开合伙人模式选择窗口
